import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-dyndev-green focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-dyndev-green/10 text-dyndev-green',
        secondary:
          'border-transparent bg-[var(--bg-secondary)] text-[var(--text-primary)]',
        destructive:
          'border-transparent bg-red-500/10 text-red-400',
        warning:
          'border-transparent bg-yellow-500/10 text-yellow-400',
        info:
          'border-transparent bg-blue-500/10 text-blue-400',
        outline:
          'text-[var(--text-primary)] border-[var(--border-color)]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
